import React, { Component } from "react";
import { map } from "lodash";
import CheckboxElement from "../UI/Checkbox";

let currentid = 6;
class FinancialPerformance extends Component {
  render() {
    const {
      data = {},
      handleChecks,
      allChecked,
      handleAllChecks,
      checkComponent
    } = this.props;

    checkComponent.some(data => data.value) === true
      ? checkComponent.map(function(data) {
          if (data.value === true) {
            currentid = data.id;
          }
          return currentid;
        })
      : (currentid = 6);
    return (
      <div className="col-xs-4">
        <div className="orange-cards checkbox-header">
          <div
            className="card-header"
            onChange={e =>
              handleAllChecks(e.target.value, e.target.id, e.target.checked)
            }
          >
            {currentid === 6 ? (
              <CheckboxElement
                heading
                inputChecked={allChecked}
                value="Financial_Performance"
                id={6}
                disable={false}
                field="Financial Performance"
                label="Financial Performance"
              />
            ) : (
              <CheckboxElement
                heading
                value="Financial_Performance"
                disable={true}
                inputChecked={false}
                field="Financial Performance"
                label="Financial Performance"
              />
            )}
          </div>
          <div className="card-content bottom-border">
            {map(data, elem => {
              return (
                <ul
                  key={elem.id}
                  onChange={e =>
                    handleChecks(
                      e.target.value,
                      e.target.id,
                      e.target.checked,
                      6,
                      "Financial_Performance"
                    )
                  }
                >
                  {currentid === 6 ? (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={allChecked}
                          id={elem.id}
                          disable={false}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  ) : (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={false}
                          id={elem.id}
                          disable={true}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  )}
                </ul>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
export default FinancialPerformance;



// WEBPACK FOOTER //
// ./src/components/Management-dashboard/FinancialPerformance.js